var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useAppSelector } from "../redux/hooks";
import { downloadAllUserImages } from "../utils/downloadAllImages";
var DiscontinuationBanner = function () {
    var _a;
    var user = useAppSelector(function (state) { return state.user; });
    var isSignedIn = useAppSelector(function (state) { return state.auth.isSignedIn; });
    var _b = useState({
        isDownloading: false,
        message: "",
    }), downloadState = _b[0], setDownloadState = _b[1];
    var handleDownloadAllImages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = user === null || user === void 0 ? void 0 : user.workspaces) === null || _a === void 0 ? void 0 : _a.length)) {
                        setDownloadState({
                            isDownloading: false,
                            message: "No workspaces found.",
                        });
                        return [2 /*return*/];
                    }
                    setDownloadState({
                        isDownloading: true,
                        message: "Starting download...",
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, downloadAllUserImages(user.workspaces, function (progress) {
                            setDownloadState({
                                isDownloading: progress.status !== "complete" && progress.status !== "error",
                                message: progress.message,
                            });
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    setDownloadState({
                        isDownloading: false,
                        message: "Download failed. Please try again.",
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "fixed left-0 right-0 z-[9999] border-b border-black/10 bg-orange text-black shadow-sm", style: {
            top: "var(--app-titlebar-height)",
            minHeight: "var(--app-discontinuation-banner-height)",
        }, role: "status", "aria-live": "polite" },
        React.createElement("div", { className: "mx-auto flex max-w-screen-2xl flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 py-2 text-center text-sm font-medium leading-snug" },
            React.createElement("span", null,
                "Substratum will be discontinued on ",
                React.createElement("strong", null, "March 31st"),
                "."),
            React.createElement("span", null,
                "All associated data will be deleted by ",
                React.createElement("strong", null, "June 1st"),
                "."),
            isSignedIn && ((_a = user === null || user === void 0 ? void 0 : user.workspaces) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement("span", { className: "flex items-center gap-2" },
                downloadState.isDownloading ? (React.createElement("span", { className: "inline-flex items-center gap-1.5" },
                    React.createElement("svg", { className: "h-4 w-4 animate-spin", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
                        React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
                        React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })),
                    React.createElement("span", null, downloadState.message))) : (React.createElement("button", { onClick: handleDownloadAllImages, className: "inline-flex items-center gap-1 rounded bg-black/10 px-2 py-0.5 transition-colors hover:bg-black/20" },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 2 },
                        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" })),
                    "Download all images")),
                !downloadState.isDownloading && downloadState.message && (React.createElement("span", { className: "text-xs" }, downloadState.message)))) : (React.createElement("span", null,
                "Need support migrating your data out of the platform? Reach out at",
                " ",
                React.createElement("a", { className: "underline underline-offset-4", href: "mailto:support@cmdshift.studio" }, "support@cmdshift.studio"),
                ".")))));
};
export default DiscontinuationBanner;
